<!-- Breadcrumb solo en modo página -->
@if (!drawerMode) {
<app-page-breadcrumb [pageTitle]="isEditing ? 'Editar Contacto' : 'Nuevo Contacto'"></app-page-breadcrumb>
}

<!-- Modo drawer: form directo | Modo página: con card wrapper -->
@if (drawerMode) {
<div class="p-6">
  <ng-container *ngTemplateOutlet="formContent" />
</div>
} @else {
<div class="grid grid-cols-1 gap-6">
  <app-component-card [title]="isEditing ? 'Editar Contacto' : 'Nuevo Contacto'" desc="Complete los datos del contacto">
    <ng-container *ngTemplateOutlet="formContent" />
  </app-component-card>
</div>
}

<ng-template #formContent>
    <!-- Loading -->
    @if (loading) {
      <div class="flex justify-center items-center py-12">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div>
        <span class="ml-3 text-gray-500 dark:text-gray-400">Cargando datos...</span>
      </div>
    }

    <!-- Error -->
    @if (error) {
      <div class="mb-4 p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20">
        <div class="flex items-center gap-3">
          <svg class="w-5 h-5 text-error-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <p class="text-error-600 dark:text-error-400">{{ error }}</p>
        </div>
      </div>
    }

    <!-- Formulario -->
    @if (!loading) {
      <form [formGroup]="form" (ngSubmit)="guardar()" class="space-y-5">

        <!-- Responsable — editable solo con permiso de edición sobre contactos (inc39) -->
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Responsable
          </label>
          @if (puedeEditarResponsable) {
            <app-entity-select
              [value]="form.value.userPropietyId"
              (valueChange)="form.patchValue({ userPropietyId: $event })"
              (selected)="onOwnerSelected($event)"
              [displayText]="ownerDisplayName"
              [searchFn]="userSearch"
              [labelFn]="userLabel"
              [sublabelFn]="userSublabel"
              [allowClear]="false"
              placeholder="Buscar usuario por nombre o correo…" />
          } @else {
            <div class="h-11 w-full rounded-lg border border-gray-300 dark:border-gray-700 bg-gray-100 dark:bg-gray-800 px-4 py-2.5 text-sm text-gray-800 dark:text-white/90 flex items-center">
              {{ ownerDisplayName || 'Sin asignar' }}
            </div>
          }
        </div>

        <!-- Nombre y Apellido -->
        <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
              Nombre <span class="text-error-500">*</span>
            </label>
            <input
              type="text"
              formControlName="fullname"
              placeholder="Nombre"
              maxlength="100"
              class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"
              [class.border-error-500]="hasError('fullname')"
              [class.border-gray-300]="!hasError('fullname')"
            />
            @if (hasError('fullname')) {
              <p class="mt-1.5 text-sm text-error-500">{{ getError('fullname') }}</p>
            }
          </div>

          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
              Apellido
            </label>
            <input
              type="text"
              formControlName="lastname"
              placeholder="Apellido"
              maxlength="100"
              class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"
              [class.border-error-500]="hasError('lastname')"
              [class.border-gray-300]="!hasError('lastname')"
            />
            @if (hasError('lastname')) {
              <p class="mt-1.5 text-sm text-error-500">{{ getError('lastname') }}</p>
            }
          </div>
        </div>

        <!-- Email y Teléfono -->
        <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
              Email
            </label>
            <input
              type="email"
              formControlName="mail"
              placeholder="email@ejemplo.com"
              maxlength="150"
              class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"
              [class.border-error-500]="hasError('mail')"
              [class.border-gray-300]="!hasError('mail')"
            />
            @if (hasError('mail')) {
              <p class="mt-1.5 text-sm text-error-500">{{ getError('mail') }}</p>
            }
          </div>

          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
              Teléfono/Celular 
            </label>
            <app-phone-input-flag
              formControlName="phone"
              [countries]="phoneCountries"
              placeholder="Número de teléfono/Celular" />
            @if (hasError('phone')) {
              <p class="mt-1.5 text-sm text-error-500">{{ getError('phone') }}</p>
            }
          </div>
        </div>

        <!-- Cargo/Posición -->
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Cargo/Posición
          </label>
          <input
            type="text"
            formControlName="position"
            placeholder="Cargo o posición"
            maxlength="100"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"
          />
        </div>

        <!-- Catálogos: State Lead, Cycle, Origin -->
        <div class="grid grid-cols-1 gap-5 sm:grid-cols-3">
          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
              Estado
            </label>
            <select
              formControlName="idContactState"
              [class.border-error-500]="hasError('idContactState')"
              [class.border-gray-300]="!hasError('idContactState')"
              class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800"
            >
              <option [ngValue]="null">Seleccione un estado</option>
              @for (state of contactStates; track state.id) {
                <option [ngValue]="state.id">{{ state.name }}</option>
              }
            </select>
            @if (hasError('idContactState')){
              <p class="mt-1.5 text-sm text-error-500">{{ getError('idContactState') }}</p>
            }
          </div>

          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
              Ciclo
              <span class="text-error-500">*</span>
            </label>
            <select
              formControlName="idContactCycle"
              [class.border-error-500]="hasError('idContactCycle')"
              [class.border-gray-300]="!hasError('idContactCycle')"
              class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800"
            >
              <option [ngValue]="null">Seleccione un ciclo</option>
              @for (cycle of contactCycles; track cycle.id) {
                <option [ngValue]="cycle.id">{{ cycle.name }}</option>
              }
            </select>
            @if (hasError('idContactCycle')){
              <p class="mt-1.5 text-sm text-error-500">{{ getError('idContactCycle') }}</p>
            }
          </div>

          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
              Origen
            </label>
            <select
              formControlName="idOrigin"
              [class.border-error-500]="hasError('idOrigin')"
              [class.border-gray-300]="!hasError('idOrigin')"
              class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800"
            >
              <option [ngValue]="null">Seleccione un origen</option>
              @for (origin of contactOrigins; track origin.id) {
                <option [ngValue]="origin.id">{{ origin.name }}</option>
              }
            </select>
               @if (hasError('idOrigin')){
            <p class="mt-1.5 text-sm text-error-500">{{ getError('idOrigin') }}</p>
          }
          </div>
       
        </div>


        <!-- Score -->
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Score <span class="text-xs text-gray-400 font-normal">(0–100)</span>
            @if(!isEditing){
              <span class="ml-2 inline-block px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded dark:bg-gray-800 dark:text-gray-400">
        Automático
      </span>
            }
          </label>
          <input
            type="number"
            formControlName="score"
            min="0"
            max="100"
            placeholder="0"
            [readOnly]="!isEditing"
            [disabled]="!isEditing"
            [class.opacity-50]="!isEditing"
            [class.cursor-not-allowed]="!isEditing"
            class="dark:bg-dark-900 h-11 w-40 rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"
          />
        </div>

        <!-- ======== Atributos Personalizados ======== -->
        @if (loadingAttributes) {
          <div class="flex items-center gap-2 py-2">
            <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-500"></div>
            <span class="text-sm text-gray-500 dark:text-gray-400">Cargando atributos personalizados...</span>
          </div>
        }

        @if (!loadingAttributes && attributeEntries.length > 0) {
          <div class="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 p-5">
            <p class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-4">Atributos Personalizados</p>

            <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
              @for (entry of attributeEntries; track entry.definition.id) {

                @if (entry.definition.type === 'text') {
                  <div>
                    <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
                      {{ entry.definition.name }}
                    </label>
                    <input
                      type="text"
                      [(ngModel)]="entry.strValue"
                      [ngModelOptions]="{standalone: true}"
                      [name]="'attr_' + entry.definition.id"
                      placeholder="Ingrese valor..."
                      class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"
                    />
                  </div>
                }

                @if (entry.definition.type === 'number') {
                  <div>
                    <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
                      {{ entry.definition.name }}
                    </label>
                    <input
                      type="number"
                      [(ngModel)]="entry.intValue"
                      [ngModelOptions]="{standalone: true}"
                      [name]="'attr_' + entry.definition.id"
                      placeholder="Ingrese número..."
                      class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"
                    />
                  </div>
                }

                @if (entry.definition.type === 'list') {
                  <div>
                    <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
                      {{ entry.definition.name }}
                    </label>
                    <select
                      [(ngModel)]="entry.strListValue"
                      [ngModelOptions]="{standalone: true}"
                      [name]="'attr_' + entry.definition.id"
                      class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800"
                    >
                      <option value="">-- Seleccionar --</option>
                      @for (opt of entry.listOptionsParsed; track opt) {
                        <option [value]="opt">{{ opt }}</option>
                      }
                    </select>
                  </div>
                }

                @if (entry.definition.type === 'boolean') {
                  <div class="flex items-center">
                    <app-switch
                      [defaultChecked]="entry.bolValue"
                      [label]="entry.definition.name"
                      (valueChange)="entry.bolValue = $event"
                    />
                  </div>
                }

              }
            </div>
          </div>
        }
        <!-- ======== Fin Atributos Personalizados ======== -->

        <!-- ======== Empresas Asociadas ======== -->
        <div class="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 p-5">
          <p class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-4">Empresas Asociadas</p>

          <!-- Search and Add Section -->
          <div class="space-y-3 mb-4">
            <!-- Company search input -->
            <div class="relative">
              <label class="mb-1.5 block text-xs font-medium text-gray-600 dark:text-gray-400">
                Buscar empresa por nombre
              </label>
              <div class="relative">
                <input
                  type="text"
                  [value]="companySearchTerm"
                  (input)="onCompanySearchInput($any($event.target).value)"
                  (blur)="hideCompanyDropdownDelayed()"
                  placeholder="Escriba al menos 2 caracteres para buscar..."
                  class="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-brand-500 pr-8"
                />
                @if (searchingCompanies) {
                  <div class="absolute right-2.5 top-2.5">
                    <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-500"></div>
                  </div>
                }
              </div>

              <!-- Dropdown results -->
              @if (showCompanyDropdown && companySearchResults.length > 0) {
                <div class="absolute z-50 mt-1 w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg max-h-48 overflow-y-auto">
                  @for (company of companySearchResults; track company.id) {
                    <button
                      type="button"
                      (click)="selectCompany(company)"
                      class="w-full flex items-center gap-3 px-3 py-2 hover:bg-gray-50 dark:hover:bg-gray-700 text-left transition-colors">
                      <!-- Avatar -->
                      <div class="flex-shrink-0 flex h-8 w-8 items-center justify-center rounded-full text-xs font-semibold {{ getCompanyAvatarColor({id: company.id, commercialName: company.commercialName}) }}">
                        {{ getCompanyInitials({id: company.id, commercialName: company.commercialName}) }}
                      </div>
                      <div class="min-w-0 flex-1">
                        <p class="text-sm font-medium text-gray-900 dark:text-white truncate">
                          {{ company.commercialName }}
                        </p>
                        @if (company.phone) {
                          <p class="text-xs text-gray-500 dark:text-gray-400 truncate">{{ company.phone }}</p>
                        }
                      </div>
                    </button>
                  }
                </div>
              }
            </div>

            <!-- Selected company + extra fields -->
            @if (selectedCompanyToAdd) {
              <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
                <div>
                  <label class="mb-1.5 block text-xs font-medium text-gray-600 dark:text-gray-400">
                    Cargo / Posición (opcional)
                  </label>
                  <input
                    type="text"
                    [(ngModel)]="newCompanyPosition"
                    [ngModelOptions]="{standalone: true}"
                    placeholder="Ej: Director, Gerente..."
                    maxlength="100"
                    class="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-brand-500"
                  />
                </div>
                <div class="flex items-end gap-3">
                  <app-switch
                    [defaultChecked]="newCompanyIsPrimary"
                    label="Empresa principal"
                    (valueChange)="newCompanyIsPrimary = $event"
                  />
                  <button
                    type="button"
                    (click)="agregarEmpresa()"
                    class="px-4 py-2 bg-brand-500 text-white rounded-lg hover:bg-brand-600 text-sm font-medium">
                    Agregar
                  </button>
                </div>
              </div>
            }
          </div>

          <!-- List of associated companies -->
          @if (asociatedCompanies.length > 0) {
            <div class="space-y-2">
              @for (entry of asociatedCompanies; track $index) {
                <div class="flex items-center gap-3 p-3 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                  <!-- Avatar -->
                  <div class="flex-shrink-0 flex h-9 w-9 items-center justify-center rounded-full text-sm font-semibold {{ getCompanyAvatarColor(entry.company) }}">
                    {{ getCompanyInitials(entry.company) }}
                  </div>

                  <!-- Company info -->
                  <div class="min-w-0 flex-1">
                    <div class="flex items-center gap-2 flex-wrap">
                      <span class="text-sm font-medium text-gray-900 dark:text-white">
                        {{ entry.company.commercialName }}
                      </span>
                      @if (entry.isPrimary) {
                        <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium bg-brand-50 text-brand-700 dark:bg-brand-900 dark:text-brand-300">
                          <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                          </svg>
                          Principal
                        </span>
                      }
                    </div>
                    <div class="flex items-center gap-2 mt-0.5 flex-wrap">
                      @if (entry.position) {
                        <span class="text-xs text-gray-500 dark:text-gray-400 italic">{{ entry.position }}</span>
                      }
                      @if (entry.company.phone) {
                        <span class="text-xs text-gray-400 dark:text-gray-500">·</span>
                        <span class="text-xs text-gray-500 dark:text-gray-400">{{ entry.company.phone }}</span>
                      }
                    </div>
                  </div>

                  <!-- Actions -->
                  <div class="flex items-center gap-1 flex-shrink-0">
                    <!-- Toggle primary -->
                    <button
                      type="button"
                      (click)="togglePrimaryEmpresa($index)"
                      [title]="entry.isPrimary ? 'Quitar como principal' : 'Marcar como principal'"
                      class="p-1.5 rounded-lg transition-colors"
                      [class.text-brand-500]="entry.isPrimary"
                      [class.hover:text-brand-600]="entry.isPrimary"
                      [class.text-gray-400]="!entry.isPrimary"
                      [class.hover:text-gray-600]="!entry.isPrimary"
                      [class.dark:hover:text-gray-300]="!entry.isPrimary">
                      <svg class="w-4 h-4" [attr.fill]="entry.isPrimary ? 'currentColor' : 'none'" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"></path>
                      </svg>
                    </button>
                    <!-- Remove -->
                    <button
                      type="button"
                      (click)="quitarEmpresa($index)"
                      title="Quitar empresa"
                      class="px-3 py-1 text-red-500 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300 text-sm">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                      </svg>
                    </button>
                  </div>
                </div>
              }
            </div>
          } @else {
            <div class="text-center py-6 text-gray-400 dark:text-gray-500">
              <svg class="w-8 h-8 mx-auto mb-2 opacity-50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
              </svg>
              <p class="text-sm">Sin empresas asociadas. Use el buscador de arriba para agregar.</p>
            </div>
          }
        </div>
        <!-- ======== Fin Empresas Asociadas ======== -->

        <!-- Botones -->
        <div class="flex justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
          <app-button variant="outline" type="button" (btnClick)="cancelar()">
            Cancelar
          </app-button>
          <app-button type="button" [disabled]="saving" (btnClick)="guardar()">
            @if (saving) {
              <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
            }
            {{ isEditing ? 'Actualizar' : 'Guardar' }}
          </app-button>
        </div>
      </form>
    }
</ng-template>
